var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import TextureReference from "grimoirejs-fundamental/ref/Material/TextureReference";
export default class DefaultPBRMetallicRoughnessInstanciator {
    tryInstanciate(matFactory, materialData, textures, gltfData, parser) {
        return __awaiter(this, void 0, void 0, function* () {
            if (materialData["pbrMetallicRoughness"]) {
                const material = yield matFactory.instanciate("gltf-pbr-metallic-roughness");
                const pass = material.techniques["default"].passes[0];
                this.__applyPBRMetallicRoughnessParameters(materialData, pass, textures);
                return material;
            }
            else {
                return null;
            }
        });
    }
    __applyPBRMetallicRoughnessParameters(materialData, pass, textures) {
        const pmr = materialData["pbrMetallicRoughness"];
        if (pmr.baseColorFactor) {
            pass.setArgument("baseColorFactor", pmr.baseColorFactor, null);
        }
        if (pmr.baseColorTexture) {
            pass.setArgument("baseColorTexture", new TextureReference(textures[pmr.baseColorTexture.index]), null);
        }
        if (pmr.metallicFactor) {
            pass.setArgument("metallicFactor", pmr.metallicFactor, null);
        }
        // TODO Remove? metallicTexture and roughnessTexture was removed from specification?
        if (pmr.metallicTexture) {
            pass.setArgument("metallicTexture", new TextureReference(textures[pmr.metallicTexture.index]), null);
        }
        if (pmr.roughnessTexture) {
            pass.setArgument("roughnessTexture", new TextureReference(textures[pmr.roughnessTexture.index]), null);
        }
        if (pmr.roughnessFactor) {
            pass.setArgument("roughnessFactor", pmr.roughnessFactor, null);
        }
        if (pmr.metallicRoughnessTexture) {
            pass.setArgument("metallicRoughnessTexture", new TextureReference(textures[pmr.metallicRoughnessTexture.index]), null);
        }
        if (materialData["emissiveFactor"]) {
            pass.setArgument("emissiveFactor", materialData.emissiveFactor, null);
        }
        if (materialData["emissiveTexture"]) {
            pass.setArgument("emissiveTexture", new TextureReference(textures[materialData.emissiveTexture.index]), null);
        }
        if (materialData["normalTexture"]) {
            pass.setArgument("normalTexture", new TextureReference(textures[materialData.normalTexture.index]), null);
        }
        if (materialData["occlusionTexture"]) {
            pass.setArgument("occlusionTexture", new TextureReference(textures[materialData.occlusionTexture.index]), null);
        }
        if (pmr.baseColorTexture) {
            pass.setArgument("baseColorTexture", new TextureReference(textures[pmr.baseColorTexture.index]), null);
        }
        if (pmr.metallicFactor) {
            pass.setArgument("metallicFactor", pmr.metallicFactor, null);
        }
        // TODO Remove? metallicTexture and roughnessTexture was removed from specification?
        if (pmr.metallicTexture) {
            pass.setArgument("metallicTexture", new TextureReference(textures[pmr.metallicTexture.index]), null);
        }
        if (pmr.roughnessTexture) {
            pass.setArgument("roughnessTexture", new TextureReference(textures[pmr.roughnessTexture.index]), null);
        }
        if (pmr.roughnessFactor) {
            pass.setArgument("roughnessFactor", pmr.roughnessFactor, null);
        }
        if (pmr.metallicRoughnessTexture) {
            pass.setArgument("metallicRoughnessTexture", new TextureReference(textures[pmr.metallicRoughnessTexture.index]), null);
        }
        if (materialData["emissiveFactor"]) {
            pass.setArgument("emissiveFactor", materialData.emissiveFactor, null);
        }
        if (materialData["emissiveTexture"]) {
            pass.setArgument("emissiveTexture", new TextureReference(textures[materialData.emissiveTexture.index]), null);
        }
        if (materialData["normalTexture"]) {
            pass.setArgument("normalTexture", new TextureReference(textures[materialData.normalTexture.index]), null);
        }
        if (materialData["occlusionTexture"]) {
            pass.setArgument("occlusionTexture", new TextureReference(textures[materialData.occlusionTexture.index]), null);
        }
    }
}



// WEBPACK FOOTER //
// ./src/Parser/MaterialInstanciator/DefaultPBRMetallicRoughnessInstanciator.ts